import Icon from 'components/shared/Icon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import { useWysiwygContext } from 'components/shared/Wysiwyg/Wysiwyg.contex';

import { BaseItemButton } from '../Base';

export const Delete = () => {
  const { props } = useWysiwygContext();

  const onClick = () => {
    props.onDelete && props.onDelete();
  };

  return (
    <BaseItemButton onClick={onClick}>
      <Icon component={Trash2} />
    </BaseItemButton>
  );
};
